import { lineIntakeSourceById } from "../pages/lineIntakeModel";
import type { ColumnAutomation, ColumnAutomationKind } from "./columnAutomations";

/**
 * One short sentence for the column header. It states what the automation
 * does for tasks in that column, in the simple present.
 */
export function columnAutomationHeadline(automation: ColumnAutomation): string {
  if (automation.kind === "intake") {
    const source = lineIntakeSourceById(automation.catalogId);
    return `Listens to ${source?.name ?? automation.name}`;
  }
  if (automation.kind === "agent-step") {
    return `Runs the ${automation.name} agent`;
  }
  if (automation.kind === "analysis") {
    return automation.health === "disabled" ? "Planning is off" : "Plans new tasks";
  }
  if (automation.kind === "custom" || automation.kind === "custom-verification") {
    return automation.name;
  }
  return FIXED_HEADLINES[automation.kind];
}

const FIXED_HEADLINES: Record<
  Exclude<ColumnAutomationKind, "intake" | "agent-step" | "custom" | "custom-verification" | "analysis">,
  string
> = {
  "pr-discussion": "Addresses pull request comments",
  "pr-checks": "Fixes failing status checks",
  "pr-closure": "Closes tasks when pull requests merge",
  "risk-score": "Scores merge confidence",
  "visual-evidence": "Captures screenshots or a short video",
};

/**
 * Rows every column header reserves. The largest column sets the count so
 * card lists start at the same height across the board. Never below one.
 */
export function columnAutomationHeaderRowCount(columns: ReadonlyArray<ReadonlyArray<ColumnAutomation>>): number {
  return Math.max(1, ...columns.map((automations) => automations.length));
}

export const IMPLEMENT_AGENT_NODE_ID = "implementation-agent-no-issue";

const SPLIT_CONFIG_NODE_IDS = new Set(["on-pr-risk", "on-pr-visual-evidence", "on-pr-closed", IMPLEMENT_AGENT_NODE_ID]);

/** Merge confidence, visual evidence, pull-request closure, and the Implement agent open the split settings panel. */
export function columnAutomationUsesSplitConfig(nodeIds: Iterable<string | undefined>): boolean {
  for (const id of nodeIds) {
    if (id && SPLIT_CONFIG_NODE_IDS.has(id)) {
      return true;
    }
  }
  return false;
}
